// extracted by mini-css-extract-plugin
module.exports = {"link":"BreadcrumbLink_link__epqFl","active":"BreadcrumbLink_active__Yy6px"};